// extracted by mini-css-extract-plugin
module.exports = {"header":"Driver_header__1CKIU","panelHeader":"Driver_panelHeader__bvd4Z","panel":"Driver_panel__2k_SM","isActive":"Driver_isActive__2iI-9","isEdit":"Driver_isEdit__AiXOu"};